<template>
  <ul class="collapsible popout">
    <li class="collapsible-margin active">
      <div class="collapsible-header">
        <i class="material-icons">cleaning_services</i> Bot Cleanup
      </div>
      <div class="collapsible-body tech row">
        {{ getTokenString() }}
        <p v-if="roll != 6">
          Take the card set aside at the start of the bot’s turn and place it
          face down in slot 1.
        </p>
        Then add cards from the bot deck, face down, until all the remaining
        slots are filled. <br /><br />If the bot deck is empty and you would
        normally add a card from the bot deck to a slot, move the top card from
        the dynasty deck into the bot discard and then shuffle the bot discard
        to form a new bot deck. Then continue adding cards to slots as normal.
        <br /><br />When the ascension card is added to the bot discard, the bot
        becomes an empire. Flip its state card to the empire side. From this
        point forward, use the nation’s empire table when resolving bot cards.
        <br /><br />If you’re playing against the Utopians, whenever the bot
        deck is empty and you would normally add a card from the bot deck to a
        slot, first resolve its journey card effect, as listed below its
        reference table. Then shuffle the bot discard pile to form a new bot
        deck and continue to add cards.
      </div>
    </li>
  </ul>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import store from "../store.js";

export default defineComponent({
  setup() {
    onMounted(() => {
      var elems = document.querySelectorAll(".collapsible");
      window.M.Collapsible.init(elems, {});
    });

    function getTokenString() {
      if (store.bot.roll == 6) {
        return "Bot rolled a 6. Do not place a token on the market.";
      }
      switch (store.bot.nation.name) {
        case "qin":
          return `Add a population to the card in the number ${store.bot.roll} space of the market.`;
        case "carthaginians":
          return `Add 2 materials to the card in the number ${store.bot.roll} space of the market.`;
        default:
          return `Add a progress to the card in the number ${store.bot.roll} space of the market.`;
      }
    }
    return {
      roll: store.bot.roll,
      getTokenString,
    };
  },
});
</script>

<style></style>
